import { render, staticRenderFns } from "./TheAccountBar.vue?vue&type=template&id=3923d158&"
import script from "./TheAccountBar.vue?vue&type=script&lang=js&"
export * from "./TheAccountBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports